<template>
  <div class="columns is-multiline">
    <div class="column is-3">
      <b-field :label="$t('addEditBailleur.informationsBancaires.libelleBanque')">
        <b-input v-model="bailleur.rib.banque"></b-input>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('addEditBailleur.informationsBancaires.titulaire')">
        <b-input v-model="bailleur.rib.titulaire"></b-input>
      </b-field>
    </div>
    <div class="column is-3">
      <input-iban :label="$t('addEditBailleur.informationsBancaires.IBAN')"
                            v-model="bailleur.rib.iban"/>
    </div>
    <div class="column is-3">
      <b-field :label="$t('addEditBailleur.informationsBancaires.BIC')">
        <b-input v-model="bailleur.rib.bic"></b-input>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('addEditBailleur.informationsBancaires.modePaiement')">
        <b-select v-model="bailleur.modeReglementId" expanded>
          <option></option>
          <option v-for="modeReglement in modesReglement"
                  :key="modeReglement.id"
                  :value="modeReglement.id">
            {{modeReglement.libelle}}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('addEditBailleur.informationsBancaires.ordreCheque')">
        <b-input v-model="bailleur.ordreCheque"></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import InputIban from '@/components/general/inputIban';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    bailleur: {
      type: Object,
      required: true,
    },
  },
  components: {
    InputIban,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
